import request from "@/utils/request";
import qs from "qs";
// 获取产品资料
export function xcBankAccSetup(data) {
  return request({
    url: "api/xcBankAccSetup",

    method: "post",
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/reservation.js